import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { Badge, Card, IconButton } from "@mui/material";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";
import ContactAvatar from "components/UpStyled/ContactAvatar";
import { AccountContext } from "context/account";
import { nanoid } from "nanoid";
import qs from "query-string";
import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import api from "services/api";
import ChatRoom from "./chatroom";

const smartdate = require("smartdate");
smartdate.init();

const MessagePanel = ({ setRightDrawer }) => {
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);
  let pid = urlObj?.query.pid ?? urlObj?.query.id ?? "";
  if (!pid.startsWith("project_")) pid = "";

  const account = useContext(AccountContext);
  let userid = account.id;
  const [chats, setChats] = useState([]);
  const [contactlist, setContactList] = useState([]);
  const [currentRoom, setCurrentRoom] = useState(null);
  const [searchTxt, setSearchTxt] = useState(pid);

  const refresh = () => {
    try {
      api.chatroom.listChatRoom("all", "", "").then(({ data }) => {
        var result = data.chats.filter((chat) => chat.totalmsgcnt > 0).slice(0, 10);
        setChats(result);
        setCurrentRoom(null);
        return data;
      });
    } catch (err) {
      toast.error(`listChatRoom failed!`);
      console.log(err);
    }
    try {
      api.chatroom.listContacts("all").then(({ data }) => {
        setContactList(data.contacts);
        return data;
      });
    } catch (err) {
      toast.error(`listContacts failed!`);
      console.log(err);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  var filteredChats = chats;
  var filteredContacts = [];
  if (searchTxt != "") {
    const searchArray = searchTxt.split(/[\s,]+/);
    filteredChats = chats.filter((chat) => {
      for (var s of searchArray) {
        if (
          chat.name.toLowerCase().indexOf(s.toLowerCase()) == -1 &&
          (chat.regardingname === null ||
            chat.regardingname.toLowerCase().indexOf(s.toLowerCase()) == -1) &&
          (chat.regardingid === null || chat.regardingid !== s)
        )
          return false;
      }
      return true;
    });
    for (var contact of contactlist) {
      if (
        chats.filter((c) => {
          return c.regardingid === "" && c.contactid === contact.id;
        }).length > 0
      )
        continue;
      var match = true;
      for (var s of searchArray) {
        if (
          contact.name.toLowerCase().indexOf(s.toLowerCase()) === -1 &&
          contact.email.toLowerCase().indexOf(s.toLowerCase()) === -1
        ) {
          match = false;
          break;
        }
      }
      if (match) filteredContacts.push(contact);
    }
  }

  const renderProfiles = filteredChats.map((chat) => (
    <SuiBox
      key={nanoid()}
      component="li"
      display="flex"
      alignItems="center"
      py={1}
      onClick={() => {
        setCurrentRoom(chat);
      }}
      sx={{ cursor: "pointer" }}
    >
      <SuiBox mr={0.5}>
        <Badge variant="dot" color="error" invisible={chat.ts <= chat.viewts}>
          <ContactAvatar room={chat} size="xs" />
        </Badge>
      </SuiBox>
      <SuiBox className="w-full">
        <SuiBox className="flex justify-between items-center">
          <SuiBox className="flex items-center">
            <SuiTypography variant="button" fontWeight="medium">
              {chat.name}
            </SuiTypography>
            {chat.regardingname && (
              <Link
                to={
                  chat.regardingownerid == userid
                    ? `/produce/all-projects?id=${chat.regardingid}`
                    : `/job/requests?id=${chat.regardingid}`
                }
                target="_blank"
                style={{ color: "inherit" }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <SuiTypography variant="button" sx={{ ml: 1 }}>
                  (
                  <SuiTypography
                    sx={{ textDecoration: "underline" }}
                    display="inline"
                    variant="button"
                  >
                    {chat.regardingname}
                  </SuiTypography>
                  )
                </SuiTypography>
              </Link>
            )}
          </SuiBox>
          <SuiTypography variant="caption">{smartdate.format(new Date(chat.ts))}</SuiTypography>
        </SuiBox>
        <div className="flex justify-between">
          <SuiTypography
            variant="caption"
            textTransform="none"
            sx={{
              width: "100%",
              minHeight: "28px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "2",
              WebkitBoxOrient: "vertical",
            }}
          >
            {chat.lastcontent}
          </SuiTypography>
        </div>
      </SuiBox>
    </SuiBox>
  ));

  if (currentRoom)
    return (
      <SuiBox sx={{ width: "500px" }}>
        <ChatRoom key={currentRoom.id} {...currentRoom} backaction={refresh} />
      </SuiBox>
    );

  //console.log('contactlist', contactlist)
  return (
    <Card sx={{ height: "90vh", maxHeight: "90vh", width: "500px" }}>
      <SuiBox pt={1} px={1}>
        <Link
          to={`/messages`}
          target="_self"
          style={{ color: "inherit" }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <SuiButton
            sx={{ mx: 0, px: 1, fontSize: 18, textTransform: "none" }}
            size="medium"
            variant="text"
            color="dark"
          >
            Messages
          </SuiButton>
        </Link>
        <IconButton
          aria-label="close"
          onClick={() => {
            setRightDrawer(0);
          }}
          sx={{
            position: "absolute",
            right: 0,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </SuiBox>
      <SuiBox sx={{ px: 1, pt: 0.5, minHeight: "53px" }}>
        <SuiInput
          autoFocus
          placeholder="Search by contact name or project name"
          className="w-full grow"
          size="medium"
          value={searchTxt}
          onChange={(event) => setSearchTxt(event.target.value)}
          icon={{
            component: searchTxt ? (
              <ClearIcon
                onClick={() => {
                  setSearchTxt("");
                }}
              />
            ) : (
              <SearchIcon />
            ),
            direction: "left",
          }}
        />
      </SuiBox>
      <SuiBox p={1} sx={{ overflowY: "auto" }}>
        <SuiBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
          {renderProfiles}
          {filteredContacts.length > 0 && (
            <SuiBox>
              {filteredContacts.map((contact) => (
                <SuiBox
                  key={nanoid()}
                  component="li"
                  display="flex"
                  alignItems="center"
                  py={1}
                  mb={1}
                  onClick={async () => {
                    try {
                      const { data } = await api.chatroom.addChatRoom({
                        userids: [contact.id],
                      });
                      setCurrentRoom(data);
                    } catch (err) {
                      toast.error(`addChatRoom failed!`);
                      console.log(err);
                      return;
                    }
                  }}
                  sx={{ cursor: "pointer" }}
                >
                  <SuiBox mr={0.5}>
                    <ContactAvatar contact={contact} size="xs" />
                  </SuiBox>
                  <SuiBox className="w-full">
                    <SuiBox className="flex justify-between items-center">
                      <SuiBox className="flex items-center">
                        <SuiTypography variant="button" fontWeight="medium">
                          {contact.name}
                        </SuiTypography>
                      </SuiBox>
                      <SuiTypography variant="caption">
                        {contact.account_type == "ma" ? "Manufacturer" : "Designer"}
                      </SuiTypography>
                    </SuiBox>
                    <div className="flex justify-between">
                      <SuiTypography
                        variant="caption"
                        textTransform="none"
                        sx={{
                          width: "100%",
                          minHeight: "28px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: "2",
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        {contact.email}
                      </SuiTypography>
                    </div>
                  </SuiBox>
                </SuiBox>
              ))}
            </SuiBox>
          )}
        </SuiBox>
      </SuiBox>
    </Card>
  );
};

export default MessagePanel;
